/* eslint-disable no-unreachable */
import { asyncThunkCreator, buildCreateSlice } from "@reduxjs/toolkit";
import { isArray, isEqual, isObject, transform } from "lodash";

export const hasAccess = ({ type, resource }) => {
  try {
    //* get user resources
    let isTrue = false;
    let resourcesArray = [];
    let { RESOURCES } = JSON.parse(localStorage.getItem("activeSession"));

    if (RESOURCES) {
      resourcesArray = [...RESOURCES];
    }

    resourcesArray.push({
      RESOURCE_ID: 0,
      RESOURCE_NAME: "Dashboard",
      URL: "/dashboard",
    });

    if (type === "path") {
      if (resourcesArray) {
        for (let index = 0; index <= resourcesArray.length; index++) {
          if (
            resourcesArray[index] &&
            `${resourcesArray[index]?.URL?.toLowerCase()}` ===
              resource?.toLowerCase()
          ) {
            isTrue = true;
          }
        }
      }
      return isTrue;
    } else if (type === "name") {
      if (resourcesArray) {
        //check availability of resource permission
        for (let index = 0; index <= resourcesArray?.length; index++) {
          //Strip leading * for main menus
          let _resource = "";
          if (
            `${resourcesArray[index]?.RESOURCE_NAME.toLowerCase()}`[0] === "*"
          ) {
            _resource = `${resourcesArray[
              index
            ]?.RESOURCE_NAME.toLowerCase()}`?.substring(1);
          } else {
            _resource = `${resourcesArray[index]?.RESOURCE_NAME.toLowerCase()}`;
          }
          if (_resource === resource?.toLowerCase()) {
            isTrue = true;
          }
        }
      }
      return isTrue;
    } else {
      return false;
    }
  } catch (err) {
    return false;
  }
};

export const getAPIHeaders = (queryParams = null) => {
  const activeSession = localStorage.getItem("activeSession")
    ? JSON.parse(localStorage.getItem("activeSession"))
    : null;

  return {
    headers: {
      Authorization: `Bearer ${activeSession?.TOKEN}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    params: queryParams,
    validateStatus: (status) => {
      return status < 500;
    },
  };
};

export const createSliceWithThunks = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const dateFormat = "DD-MMM-YYYY";
export const dateFormatWithTime = "DD-MMM-YYYY HH:mm:ss";
export const oracleDateFormat = "DD-MMM-YYYY hh:mm:ss A";

export const basicAuth = (email, password) => {
  let auth = "Basic " + Buffer.from(email + ":" + password).toString("base64");
  return auth;
};

export const unformatNumber = (number) => {
  return number && number.replace(/,/g, "");
};

export const formatNumber = (_number) => {
  if (_number !== null && _number !== undefined) {
    let _formattedNumber = "";
    if (_number !== "") {
      //control Zero (0)
      if (_number?.toString() === "0") {
        return _number;
      } else {
        let number = _number.toString();
        let last = number.charAt(number.length - 1);

        if (last === ".") {
          if (number.substr(0, number.length - 1).includes(".")) {
            _formattedNumber = number.substr(0, number.length - 1);
          } else {
            _formattedNumber = _number;
          }
        } else {
          let cleaned = number.replace(/,/g, "");
          _formattedNumber = new Intl.NumberFormat().format(
            parseFloat(cleaned)
          );
        }
      }
      // _formattedNumber = new Intl.NumberFormat("en-EN").format(number);
    }
    return _formattedNumber;
  }
};

export const strTrim = (x) => {
  return x.replace(/^\s+|\s+$/gm, "");
};

export const separateWord = (x = "") => {
  return x.replace(/([a-z])([A-Z])/g, "$1 $2");
};

export const reverseString = (str) => {
  return str.split("").reverse().join("");
};

export const weekDates = (current = null) => {
  let _current = current !== null ? new Date(current) : new Date();
  let weekDates = [];

  for (let i = 1; i <= 7; i++) {
    let first = _current.getDate() - _current.getDay() + i;
    let day = new Date(_current.setDate(first)).toISOString().slice(0, 10);
    weekDates.push(day);
  }

  return weekDates;
};

export const randomizePwd = (length) => {
  let result = "";
  let characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const base64FileDetails = (base64String) => {
  let _strings = base64String.split(",");
  let file = {};
  switch (
    _strings[0] //check files's extension
  ) {
    case "data:application/pdf;base64":
      file = {
        ...file,
        type: "Document",
        extension: "pdf",
      };
      break;
    case "data:image/jpeg;base64":
      file = {
        ...file,
        type: "Image",
        extension: "jpeg",
      };
      break;
    case "data:image/png;base64":
      file = {
        ...file,
        type: "Image",
        extension: "png",
      };
      break;
    default:
      //should write cases for more images types
      file = {
        ...file,
        type: "Image",
        extension: "jpg",
      };
      break;
  }

  return file;
};

export const testWhite = (x) => {
  let white = new RegExp(/^\s$/);
  return white.test(x.charAt(0));
};

export const wordWrap = (str, maxWidth) => {
  let newLineStr = "\n";
  let res = "";
  while (str.length > maxWidth) {
    let found = false;
    // Inserts new line at first whitespace of the line
    for (let i = maxWidth - 1; i >= 0; i--) {
      if (testWhite(str.charAt(i))) {
        res = res + [str.slice(0, i), newLineStr].join("");
        str = str.slice(i + 1);
        found = true;
        break;
      }
    }
    // Inserts new line at maxWidth position, the word is too long to wrap
    if (!found) {
      res += [str.slice(0, maxWidth), newLineStr].join("");
      str = str.slice(maxWidth);
    }
  }
  return res + str;
};

export const getUcfirst = (string = "") => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const getInitials = (name = "") => {
  name
    .replace(/\s+/, " ")
    .split(" ")
    .slice(0, 2)
    .map((v) => v && v[0].toUpperCase())
    .join("");
};

export const validateEmail = (email) => {
  let re =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  if (re.test(email)) {
    return true;
  } else {
    return false;
  }
};

export const validPassword = new RegExp("^(?=.*?[A-Za-z])(?=.*?[0-9]).{6,}$");

export const replaceBetween = (origin, startIndex, endIndex, insertion) => {
  return (
    origin?.substring(0, startIndex) + insertion + origin?.substring(endIndex)
  );
};

export const containsCharacter = (val) => {
  let char = val.slice(-1).toUpperCase();
  let options = ["H", "K", "M", "B", "T", "Z"];
  let valid = 0;
  options.forEach((c) => {
    valid = valid + c.includes(char);
  });
  return valid === 1;
};

export const translateEnteredAmount = (input) => {
  let _amount = unformatNumber(input.slice(0, -1));
  let char = input.slice(-1).toUpperCase();
  let _actualAmount = 0;

  switch (char) {
    case "H":
      _actualAmount = formatNumber(_amount * 100);
      return _actualAmount;
    case "K":
      _actualAmount = formatNumber(_amount * 1000);
      return _actualAmount;
    case "M":
      _actualAmount = formatNumber(_amount * 1000000);
      return _actualAmount;
    case "B":
      _actualAmount = formatNumber(_amount * 1000000000);
      return _actualAmount;
    case "T":
      _actualAmount = formatNumber(_amount * 1000000000000);
      return _actualAmount;
    case "Z":
      _actualAmount = formatNumber(_amount * 1000000000000000);
      return _actualAmount;
    default:
      return input;
  }
};

export const translateChequeStatus = (status) => {
  switch (status) {
    case "P":
      return "has been P";
    case "S":
      return "is S";
    case "U":
      return "has been used";
    case "I":
      return "is invalid";
    default:
      return "is valid";
  }
};

export const generateRandomPassword = async (length = 5) => {
  let result = "";
  let characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  let randomCharacter = await generateRandomSpecialCharacter(1);
  let randomNumber = generateRandomNumber(1);
  let randomSmall = await generateRandomSmall(2);
  result = result + "" + randomCharacter + "" + randomNumber + "" + randomSmall;
  return result;
};

export const generateRandomNumber = (length = 1) => {
  let result = "";
  let characters = "0123456789";
  let charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const generateRandomSmall = async (length = 1) => {
  let result = "";
  let characters = "abcdefghijklmnopqrstuvwxyz";
  let charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const generateRandomSpecialCharacter = async (length = 1) => {
  let result = "";
  let characters = "_.@$&*";
  let charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const getObjectDifference = async (origObj, newObj) => {
  const changes = (newObj, origObj) => {
    let arrayIndexCounter = 0;
    return transform(newObj, function (result, value, key) {
      if (!isEqual(value, origObj[key])) {
        let resultKey = isArray(origObj) ? arrayIndexCounter++ : key;
        result[resultKey] =
          isObject(value) && isObject(origObj[key])
            ? changes(value, origObj[key])
            : value;
      }
    });
  };
  return changes(newObj, origObj);
};

export const getArrayDifference = async (arrayOne, arrayTwo) => {
  const setB = new Set(arrayTwo);
  return arrayOne.filter((element) => !setB.has(element));
};

export const getBase64 = async (file, cb) => {
  let reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
    cb(reader.result);
    return true;
  };
  reader.onerror = function (error) {
    console.log("Error: ", error);
    return false;
  };
};

export const capitalizeWord = (word = "") => {
  if (word?.trim().length > 1) {
    let _rest = word.slice(1);
    return `${word.charAt(0).toUpperCase()}${_rest?.toLocaleLowerCase()}`;
  } else {
    return word?.toUpperCase();
  }
};

export const isEmpty = (val) => {
  return val === null || val?.toString()?.trim() === "" || val === undefined;
};

export const translateStatus = (status) => {
  switch (status?.toUpperCase()) {
    case "A":
      return "Active";
    case "I":
      return "Inactive";
    case "D":
      return "Draft";
    case "C":
      return "Completed";
    case "E":
      return "Evaluation";
    case "F":
      return "Testing Failed";
    case "T":
      return "Testing";
    case "N":
      return "Not Eligible";
    case "P":
      return "In Recommendation";
    case "R":
      return "Returned";
    case "S":
      return "Submitted";
    default:
      break;
  }
};

export const applicationStatus = [
  { label: "Draft", value: "D" },
  { label: "Submitted (Pending)", value: "S" },
  { label: "In Evaluation", value: "E" },
  { label: "Not Eligible", value: "N" },
  { label: "In Testing", value: "T" },
  { label: "Testing Failed", value: "F" },
  { label: "In Recommendation", value: "P" },
  { label: "Returned", value: "R" },
  { label: "Completed", value: "C" },
  { label: "Rejected", value: "X" },
];
